import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule, ModalController } from '@ionic/angular';

import { TypeUtilService } from '@core/services/utils/type-util.service';

import { DisableParameterChangesModalComponent } from '@pages/product/modals/disable-parameter-changes/disable-parameter-changes-modal.component';

import { Product, ProductTypes } from '@shared/models/products.model';
import { SharedModule } from '@shared/shared.module';

@Component({
    selector: 'app-disable-parameter-changes-inline',
    templateUrl: './disable-parameter-changes-inline.component.html',
    styleUrls: ['./disable-parameter-changes-inline.component.scss'],
    imports: [CommonModule, IonicModule, FormsModule, SharedModule]
})
export class DisableParameterChangesInlineComponent implements OnInit {
  @Input() product!: Product;

  @Output() toggleChange = new EventEmitter<boolean>();

  private readonly modalController = inject(ModalController);

  // Пытаемся получить product из инжектора (если передан через NgComponentOutlet)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly injectedProduct = inject<Product | null>('PRODUCT_DATA' as any, { optional: true });
  private initialized = false;

  // Состояние компонента
  protected isEnabled = false; // Запрет установлен

  ngOnInit(): void {
    // Если product не передан через @Input, пытаемся получить из инжектора
    if (!this.product && this.injectedProduct) {
      this.product = this.injectedProduct;
    }

    // Проверяем, что это счет - компонент должен отображаться только для счетов
    if (
      this.product &&
      (this.product.productType === ProductTypes.ACCOUNT ||
        this.product.productType === ProductTypes.SAVE_ACCOUNT ||
        this.product.productType === ProductTypes.METAL_ACCOUNT ||
        this.product.productType === ProductTypes.DEPOSIT)
    ) {
      if (!this.initialized) {
        this.initializeFromProduct();
        this.initialized = true;
      }
    }
  }

  protected async onToggleChange(event: CustomEvent): Promise<void> {
    const isChecked = event.detail.checked;

    // Если пользователь пытается выключить запрет - возвращаем toggle в исходное состояние
    if (!isChecked && this.isEnabled) {
      this.isEnabled = true;

      return;
    }

    try {
      const modal = await this.modalController.create({
        component: DisableParameterChangesModalComponent,
        handle: false,
        cssClass: 'custom',
        initialBreakpoint: 1,
        componentProps: {
          product: this.product,
          staticHeight: true
        }
      });

      await modal.present();

      const { data } = await modal.onDidDismiss();

      if (data?.success) {
        // Обновляем состояние если операция успешна
        this.product.forbiddenChange = 'true';
        this.isEnabled = true;
        this.toggleChange.emit(true);
      } else {
        // Возвращаем toggle в исходное состояние если операция не удалась
        this.isEnabled = false;
      }
    } catch (error) {
      console.error('Error opening disable parameter changes modal:', error);
      this.isEnabled = false;
    }
  }

  /**
   * Инициализация состояния из данных продукта
   */
  private initializeFromProduct(): void {
    if (!this.product) {
      return;
    }

    // forbiddenChange - запрет на изменение параметров
    this.isEnabled = TypeUtilService.isTruthy(this.product.forbiddenChange);

    console.log('DisableParameterChangesInline Debug:', {
      productId: this.product.id,
      forbiddenChange: this.product.forbiddenChange,
      isEnabled: this.isEnabled
    });
  }
}
